import { type PropsWithChildren, type ReactNode } from 'react'
import {
  Tooltip as BaseTooltip,
  type TooltipProps as BaseTooltipProps,
} from 'antd'

import * as styles from './Tooltip.styles'

export type TooltipProps = Omit<BaseTooltipProps, 'title'> & {
  enabled?: boolean
  text: ReactNode
}

export const Tooltip = ({
  text,
  children,
  enabled = true,
  mouseEnterDelay = 0.3,
  overlayClassName = '',
  ...props
}: PropsWithChildren<TooltipProps>) => {
  if (!enabled) {
    return <>{children}</>
  }

  return (
    <BaseTooltip
      {...props}
      overlayClassName={`${styles.overlay} ${overlayClassName}`}
      mouseEnterDelay={mouseEnterDelay}
      title={text}
    >
      {children}
    </BaseTooltip>
  )
}
